import React from 'react'
import { Row, Col, Pagination, PaginationItem, PaginationLink } from 'reactstrap'

function InstancesPagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

  return (
    <Row className="mt-4">
      <Col className="d-flex justify-content-center">
        <Pagination>
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink previous onClick={() => onPageChange(currentPage - 1)} />
          </PaginationItem>

          {pages.map((page) => (
            <PaginationItem key={page} active={page === currentPage}>
              <PaginationLink onClick={() => onPageChange(page)}>
                {page}
              </PaginationLink>
            </PaginationItem>
          ))}

          <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink next onClick={() => onPageChange(currentPage + 1)} />
          </PaginationItem>
        </Pagination>
      </Col>
    </Row>
  )
}

export default InstancesPagination
